import { constants } from '../../../common/Localization';
import { ColumnDefinition, ColumnTypes } from '../../../common/table/types';
import { formatCell, formatData } from './CellFormatter';
import { SummaryRow } from './MainframeTypes';

export const MainframeSummaryCostColumnDefinitions: ColumnDefinition<SummaryRow>[] = [
    {
        data: item => item.description,
        cell: item => formatCell(item.description, item.format, item.currency),
        header: constants.DESCRIPTION,
        id: 'descriptionId',
        type: ColumnTypes.TEXT,
    },
    {
        data: item => formatData(item.value, item.format, item.currency),
        cell: item => formatCell(item.value, {...item.format, align: 'right'}, item.currency),
        header: constants.AMOUNT_COLUMN_HEADER,
        id: 'valueId',
        type: ColumnTypes.NUMBER,
    },
];
